const stripStylesOnPaste = (editor) => {
  editor.plugins.get('ClipboardPipeline').on('inputTransformation', (evt, data) => {
    const viewFragment = data.content;

    // Recursively walk the view tree and clean styles from all elements
    const cleanStyles = (viewElement) => {
      if (!viewElement.is || !viewElement.is('element')) {
        return;
      }

      // Clean styles from any span element
      if (viewElement.name === 'span') {
        const styles = viewElement.getStyle ? viewElement.getStyle() : {};
        if (styles) {
          viewElement._removeStyle('color');
          viewElement._removeStyle('background-color');
          viewElement._removeStyle('font-size');
        }
      }

      // Handle styles on link elements too if necessary
      if (viewElement.name === 'a') {
        // Keep link styling that's essential (like underline)
        // but remove other unnecessary styles
        const linkStyles = viewElement.getStyle ? viewElement.getStyle() : {};
        if (linkStyles) {
          viewElement._removeStyle('color');
          viewElement._removeStyle('background-color');
          viewElement._removeStyle('font-size');
        }
      }

      // Clean white-space: pre from Google imports (breaks lists)
      if (viewElement.name === 'ul' || viewElement.name === 'ol' || viewElement.name === 'li') {
        const styles = viewElement.getStyle ? viewElement.getStyle() : {};
        if (styles && styles['white-space'] === 'pre') {
          viewElement._removeStyle('white-space');
        }
      }

      // Process all children
      for (const child of viewElement.getChildren()) {
        cleanStyles(child);
      }
    };

    // Process all root elements in the fragment
    for (const child of viewFragment.getChildren()) {
      cleanStyles(child);
    }
  });
};

export default stripStylesOnPaste;
